import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EMRService } from 'app/EMR/EMR.service';
import { MatDialog } from '@angular/material/dialog';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { AuthService } from 'app/auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WebSocketService } from 'app/EMR/webSocket.Service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-Keratometer',
  templateUrl: './Keratometer.component.html',
  styleUrls: ['./Keratometer.component.scss']
})
export class KeratometerComponent implements OnInit {
  destroykeroto$: Subject<boolean> = new Subject<boolean>()

  private dialated: boolean = true;
  private undialated: boolean = false;
  private selectValue: any;
  private dialatedcheck: string;
  private selectedDevice: any = 'TOPCON';
  private machineArray: any = [];
   private listmachineArray: any = [];
  @ViewChild('kerotoauto', { static: false }) private kerotoautoRef: ElementRef;
  @ViewChild('kerotoauto7', { static: false }) private kerotoautoRef7: ElementRef;
  constructor(private emrservice: EMRService,
    private dialog: MatDialog, private authservice: AuthService, private webSocketService: WebSocketService, private dashboardService: DashboardService) { }

  ngOnInit() {
    this.machineArray=[];
    this.listmachineArray=[];
    this.emrservice.share.pipe(takeUntil(this.destroykeroto$)).subscribe((x: any) => {
      if (x == 5) {
        setTimeout(() => {
          this.kerotoautoRef.nativeElement.focus();
        }, 1000);

      } else if (x == 7) {
        setTimeout(() => {
          this.kerotoautoRef7.nativeElement.focus();
        }, 1000);
      }
    })
    this.dialatedcheck = 'UD'
    this.emrservice.enabledisableautorefkr = true;
    this.emrservice.enabledisableautorefkr1 = true;
    this.getmachineType();
    this.getmachinedata();
  }
  getmachineType(){
     this.emrservice.getiolDetail('MACHINETYPE').subscribe((item: any) => {
      this.listmachineArray = item;
    });
  }
  getmachinedata() {
    this.emrservice.GetArNctPath(this.authservice.Loggeduser.branchid, this.selectedDevice).subscribe((item: any) => {
      this.machineArray = item;
    })
  }
  onMachineTypeChange(event: any) {
    this.getmachinedata();
  }
  onInputChange(type: any) {
    if (type == 1) {
      this.emrservice.enabledisableautorefkr = false;
    } else if (type == 2) {
      this.emrservice.enabledisableautorefkr1 = false;
    }
  }

  showOptions(event: MatCheckboxChange): void {
    this.dialatedcheck = event['value'];

  }
  sendDelete() {

    if (this.machineArray.length > 0 && this.machineArray[0]?.arpath) {
      const msg = { "message": "DELETE", "DILATIONTYPE": this.dialatedcheck, "WEBNETRAMMACHINEPATH": this.machineArray[0]?.arpath, "MACHINENAME": this.selectedDevice }
      this.webSocketService.sendMessage(msg);
      this.webSocketService.getMessages().subscribe(
        (message: any) => {
          this.dashboardService.openSnackBar(message.message, "OK");
        }, err => {
          this.dashboardService.openSnackBar("Please set server configuration", "OK");
        });
    } else {
      this.dashboardService.openSnackBar("Please set Path in configuration", "OK");
    }
  }


  sendMessage() {

      if (this.machineArray.length > 0 && this.machineArray[0]?.arpath) {
          const msg = { message: 'TRANSFER', "DILATIONTYPE": this.dialatedcheck, "WEBNETRAMMACHINEPATH": this.machineArray[0]?.arpath, "MACHINENAME": this.selectedDevice }
          this.webSocketService.sendMessage(msg);
          this.webSocketService.getMessages().subscribe(
            (message: any) => {

              if (message.message != 'Error' && message.message != 'File not found.') {

                if (this.dialatedcheck == "UD") {
                  this.emrservice.enabledisableautorefkr = false;
                  this.emrservice.enabledisableautorefkr1 = false;
                  // Un-Dilated Auto-Ref Details.......
                  this.emrservice.autoref.rs1 = message.rs1;
                  this.emrservice.autoref.rs2 = message.rs2;
                  this.emrservice.autoref.rs3 = message.rs3;
                  this.emrservice.autoref.udrs = message.udrs;
                  this.emrservice.autoref.rs5 = message.rs5;

                  this.emrservice.autoref.rc1 = message.rc1;
                  this.emrservice.autoref.rc2 = message.rc2;
                  this.emrservice.autoref.rc3 = message.rc3;
                  this.emrservice.autoref.udrc = message.udrc;
                  this.emrservice.autoref.rc5 = message.rc5;

                  this.emrservice.autoref.ra1 = message.ra1;
                  this.emrservice.autoref.ra2 = message.ra2;
                  this.emrservice.autoref.ra3 = message.ra3;
                  this.emrservice.autoref.udra = message.udra;
                  this.emrservice.autoref.ra5 = message.ra5;

                  this.emrservice.autoref.ls1 = message.ls1;
                  this.emrservice.autoref.ls2 = message.ls2;
                  this.emrservice.autoref.ls3 = message.ls3;
                  this.emrservice.autoref.udls = message.udls;
                  this.emrservice.autoref.ls5 = message.ls5;


                  this.emrservice.autoref.lc1 = message.lc1;
                  this.emrservice.autoref.lc2 = message.lc2;
                  this.emrservice.autoref.lc3 = message.lc3;
                  this.emrservice.autoref.udlc = message.udlc;
                  this.emrservice.autoref.lc5 = message.lc5;

                  this.emrservice.autoref.la1 = message.la1;
                  this.emrservice.autoref.la2 = message.la2;
                  this.emrservice.autoref.la3 = message.la3;
                  this.emrservice.autoref.udla = message.udla;
                  this.emrservice.autoref.la5 = message.la5;

                  // Un-Dilated K-Readings
                  this.emrservice.autoref.kmrp1 = message.kmrp1;
                  this.emrservice.autoref.kmrr1 = message.kmrr1;
                  this.emrservice.autoref.kmra1 = message.kmra1;

                  this.emrservice.autoref.kmrp2 = message.kmrp2;
                  this.emrservice.autoref.kmrr2 = message.kmrr2;
                  this.emrservice.autoref.kmra2 = message.kmra2;

                  this.emrservice.autoref.kmrp3 = message.kmrp3;
                  this.emrservice.autoref.kmrr3 = message.kmrr3;
                  this.emrservice.autoref.kmra3 = message.kmra3;

                  this.emrservice.autoref.kmrp4 = message.kmrp4;
                  this.emrservice.autoref.kmrr4 = message.kmrr4;
                  this.emrservice.autoref.kmra4 = message.kmra4;

                  this.emrservice.autoref.kmrp5 = message.kmrp5;
                  this.emrservice.autoref.kmrr5 = message.kmrr5;
                  this.emrservice.autoref.kmra5 = message.kmra5;


                  this.emrservice.autoref.kmlp1 = message.kmlp1;
                  this.emrservice.autoref.kmlr1 = message.kmlr1;
                  this.emrservice.autoref.kmla1 = message.kmla1;
                  this.emrservice.autoref.kmlp2 = message.kmlp2;
                  this.emrservice.autoref.kmlr2 = message.kmlr2;

                  this.emrservice.autoref.kmla2 = message.kmla2;
                  this.emrservice.autoref.kmlp3 = message.kmlp3;
                  this.emrservice.autoref.kmlr3 = message.kmlr3;
                  this.emrservice.autoref.kmla3 = message.kmla3;
                  this.emrservice.autoref.kmlp4 = message.kmlp4;

                  this.emrservice.autoref.kmlr4 = message.kmlr4;
                  this.emrservice.autoref.kmla4 = message.kmla4;
                  this.emrservice.autoref.kmlp5 = message.kmlp5;
                  this.emrservice.autoref.kmlr5 = message.kmlr5;
                  this.emrservice.autoref.kmla5 = message.kmla5;
                  console.log(this.emrservice.autoref, 'called autoref')
                } else {
                  // Dilated Auto-Ref Details....
                  this.emrservice.enabledisableautorefkr = false;
                  this.emrservice.enabledisableautorefkr1 = false;
                  this.emrservice.autoref.drs1 = message.drs1;
                  this.emrservice.autoref.drs2 = message.drs2;
                  this.emrservice.autoref.drs3 = message.drs3;
                  this.emrservice.autoref.drs = message.drs;
                  this.emrservice.autoref.drs5 = message.drs5;

                  this.emrservice.autoref.drc1 = message.drc1;
                  this.emrservice.autoref.drc2 = message.drc2;
                  this.emrservice.autoref.drc3 = message.drc3;
                  this.emrservice.autoref.drc = message.drc;
                  this.emrservice.autoref.drc5 = message.drc5;

                  this.emrservice.autoref.dra1 = message.dra1;
                  this.emrservice.autoref.dra2 = message.dra2;
                  this.emrservice.autoref.dra3 = message.dra3;
                  this.emrservice.autoref.dra = message.dra;
                  this.emrservice.autoref.dra5 = message.dra5;

                  this.emrservice.autoref.dra1 = message.dra1;
                  this.emrservice.autoref.dra2 = message.dra2;
                  this.emrservice.autoref.dra3 = message.dra3;
                  this.emrservice.autoref.dra = message.dra;
                  this.emrservice.autoref.dra5 = message.dra5;

                  this.emrservice.autoref.dra1 = message.dra1;
                  this.emrservice.autoref.dra2 = message.dra2;
                  this.emrservice.autoref.dra3 = message.dra3;
                  this.emrservice.autoref.dra = message.dra;
                  this.emrservice.autoref.dra5 = message.dra5;

                  this.emrservice.autoref.dls1 = message.dls1;
                  this.emrservice.autoref.dls2 = message.dls2;
                  this.emrservice.autoref.dls3 = message.dls3;
                  this.emrservice.autoref.dls = message.dls;
                  this.emrservice.autoref.dls5 = message.dls5;

                  this.emrservice.autoref.dlc1 = message.dlc1;
                  this.emrservice.autoref.dlc2 = message.dlc2;
                  this.emrservice.autoref.dlc3 = message.dlc3;
                  this.emrservice.autoref.dlc = message.dlc;
                  this.emrservice.autoref.dlc5 = message.dlc5;

                  this.emrservice.autoref.dla1 = message.dla1;
                  this.emrservice.autoref.dla2 = message.dla2;
                  this.emrservice.autoref.dla3 = message.dla3;
                  this.emrservice.autoref.dla = message.dla;
                  this.emrservice.autoref.dla5 = message.dla5;

                  // Dilated K-Readings.....
                  // right Side
                  this.emrservice.autoref.dkmrp1 = message.dkmrp1;
                  this.emrservice.autoref.dkmrr1 = message.dkmrr1;
                  this.emrservice.autoref.dkmra1 = message.dkmra1;
                  this.emrservice.autoref.dkmrp2 = message.dkmrp2;
                  this.emrservice.autoref.dkmrr2 = message.dkmrr2;


                  this.emrservice.autoref.dkmra2 = message.dkmra2;
                  this.emrservice.autoref.dkmlp3 = message.dkmlp3;
                  this.emrservice.autoref.dkmrr3 = message.dkmrr3;
                  this.emrservice.autoref.dkmra3 = message.dkmra3;
                  this.emrservice.autoref.dkmlp4 = message.dkmlp4;


                  this.emrservice.autoref.dkmrr4 = message.dkmrr4;
                  this.emrservice.autoref.dkmra4 = message.dkmra4;
                  this.emrservice.autoref.dkmrp5 = message.dkmrp5;
                  this.emrservice.autoref.dkmrr5 = message.dkmrr5;
                  this.emrservice.autoref.dkmra5 = message.dkmra5;


                  // left side

                  this.emrservice.autoref.dkmlp1 = message.dkmlp1;
                  this.emrservice.autoref.dkmlr1 = message.dkmlr1;
                  this.emrservice.autoref.dkmla1 = message.dkmla1;
                  this.emrservice.autoref.dkmlp2 = message.dkmlp2;
                  this.emrservice.autoref.dkmlr2 = message.dkmlr2;

                  this.emrservice.autoref.dkmla2 = message.dkmla2;
                  this.emrservice.autoref.dkmlp3 = message.dkmlp3;
                  this.emrservice.autoref.dkmlr3 = message.dkmlr3;
                  this.emrservice.autoref.dkmla3 = message.dkmla3;
                  this.emrservice.autoref.dkmlp4 = message.dkmlp4;

                  this.emrservice.autoref.dkmlr4 = message.dkmlr4;
                  this.emrservice.autoref.dkmla4 = message.dkmla4;
                  this.emrservice.autoref.dkmla4 = message.dkmla4;
                  this.emrservice.autoref.dkmlr5 = message.dkmlr5;
                  this.emrservice.autoref.dkmla5 = message.dkmla5;
                }

                this.dashboardService.openSnackBar("Data Transfered", "OK");
              } else if (message.message != 'Error' && message.message == 'File not found.') {
                this.dashboardService.openSnackBar(message.message, "OK");
              } else {
                this.dashboardService.openSnackBar("Please check configuration", "OK");
              }

            }, err => {
              this.dashboardService.openSnackBar("Please set server configuration", "OK");
            });

        } else {
          this.dashboardService.openSnackBar("Please set Path in Application Setting", "OK");
        }

      }
    
  focusautootherPage() {
    this.emrservice.content.next('6');
  }
  // Axis 
  refhelplistPOpup(type, value, typevalue: any) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroykeroto$)).subscribe(result => {
      if (result != 0) {
        if (typevalue == 1) {
          this.emrservice.enabledisableautorefkr = false;
        } else if (typevalue == 2) {
          this.emrservice.enabledisableautorefkr1 = false;
        }
        this.selectValue = result;
        this.set_kmr_values(value);
      }
    });
  }




  chkvalue(value: string) {
    if (value != null) {
      return value;
    }
    else {
      return "?";
    }
  }

  // dialatedBtn() {
  //   this.dialated = true;
  //   this.undialated = false;
  // }
  // undialatedBtn() {
  //   this.dialated = false
  //   this.undialated = true;
  // }

  refKmrPOpup(categoryType: string, valuebox: string, type: any) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: categoryType
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroykeroto$)).subscribe(result => {
      console.log(valuebox);
      if (result != 0) {
        if (type == 1) {
          this.emrservice.enabledisableautorefkr = false;
        } else if (type == 2) {
          this.emrservice.enabledisableautorefkr1 = false;
        }
        this.selectValue = result;
        this.set_kmr_values(valuebox);

      }
    });
  }
  set_kmr_values(row) {
    switch (row) {
      //Dilated row - 1
      case "d_kr_r1_p1": {
        this.emrservice.autoref.kmrp1 = this.selectValue;
        break;
      }
      case "d_kr_r1_r1": {
        this.emrservice.autoref.kmrr1 = this.selectValue;
        break;
      }
      case "d_kr_r1_a1": {
        this.emrservice.autoref.kmra1 = this.selectValue;
        break;
      }
      // row - 2
      case "d_kr_r2_p2": {
        this.emrservice.autoref.kmrp2 = this.selectValue;
        break;
      }
      case "d_kr_r2_r2": {
        this.emrservice.autoref.kmrr2 = this.selectValue;
        break;
      }
      case "d_kr_r2_a2": {
        this.emrservice.autoref.kmra2 = this.selectValue;
        break;
      }

      // row - 3
      case "d_kr_r3_a3": {
        this.emrservice.autoref.kmra3 = this.selectValue;
        break;
      }
      case "d_kr_r3_r3": {
        this.emrservice.autoref.kmrr3 = this.selectValue;
        break;
      }
      case "d_kr_r3_p3": {
        this.emrservice.autoref.kmrp3 = this.selectValue;
        break;
      }
      // row - 4
      case "d_kr_r4_p4": {
        this.emrservice.autoref.kmrp4 = this.selectValue;
        break;
      }
      case "d_kr_r4_r4": {
        this.emrservice.autoref.kmrr4 = this.selectValue;
        break;
      }
      case "d_kr_r4_a4": {
        this.emrservice.autoref.kmra4 = this.selectValue;
        break;
      }
      // row - 5
      case "d_kr_r5_p5": {
        this.emrservice.autoref.kmrp5 = this.selectValue;
        break;
      }
      case "d_kr_r5_r5": {
        this.emrservice.autoref.kmrr5 = this.selectValue;
        break;
      }
      case "d_kr_r5_a5": {
        this.emrservice.autoref.kmra5 = this.selectValue;
        break;
      }

      // row - 1
      case "d_kr_l1_p1": {
        this.emrservice.autoref.kmlp1 = this.selectValue;
        break;
      }
      case "d_kr_l1_r1": {
        this.emrservice.autoref.kmlr1 = this.selectValue;
        break;
      }
      case "d_kr_l1_a1": {
        this.emrservice.autoref.kmla1 = this.selectValue;
        break;
      }
      // row - 2
      case "d_kr_l2_p2": {
        this.emrservice.autoref.kmlp2 = this.selectValue;
        break;
      }
      case "d_kr_l2_r2": {
        this.emrservice.autoref.kmlr2 = this.selectValue;
        break;
      }
      case "d_kr_l2_a2": {
        this.emrservice.autoref.kmla2 = this.selectValue;
        break;
      }
      // row - 3
      case "d_kr_l3_p3": {
        this.emrservice.autoref.kmlp3 = this.selectValue;
        break;
      }
      case "d_kr_l3_r3": {
        this.emrservice.autoref.kmlr3 = this.selectValue;
        break;
      }
      case "d_kr_l3_a3": {
        this.emrservice.autoref.kmla3 = this.selectValue;
        break;
      }

      // row - 4
      case "d_kr_l4_p4": {
        this.emrservice.autoref.kmlp4 = this.selectValue;
        break;
      }
      case "d_kr_l4_r4": {
        this.emrservice.autoref.kmlr4 = this.selectValue;
        break;
      }
      case "d_kr_l4_a4": {
        this.emrservice.autoref.kmla4 = this.selectValue;
        break;
      }

      // row - 5
      case "d_kr_l5_p5": {
        this.emrservice.autoref.kmlp5 = this.selectValue;
        break;
      }
      case "d_kr_l5_r5": {
        this.emrservice.autoref.kmlr5 = this.selectValue;
        break;
      }
      case "d_kr_l5_a5": {
        this.emrservice.autoref.kmla5 = this.selectValue;
        break;
      }


      //Undilated
      case "un_kr_r1_p1": {
        this.emrservice.autoref.dkmrp1 = this.selectValue;
        break;
      }
      case "un_kr_r1_r1": {
        this.emrservice.autoref.dkmrr1 = this.selectValue;
        break;
      }
      case "un_kr_r1_a1": {
        this.emrservice.autoref.dkmra1 = this.selectValue;
        break;
      }


      case "un_kr_r2_p2": {
        this.emrservice.autoref.dkmrp2 = this.selectValue;
        break;
      }
      case "un_kr_r2_r2": {
        this.emrservice.autoref.dkmrr2 = this.selectValue;
        break;
      }
      case "un_kr_r2_a2": {
        this.emrservice.autoref.dkmra2 = this.selectValue;
        break;
      }

      case "un_kr_r3_p3": {
        this.emrservice.autoref.dkmrp3 = this.selectValue;
        break;
      }
      case "un_kr_r3_r3": {
        this.emrservice.autoref.dkmrr3 = this.selectValue;
        break;
      }
      case "un_kr_r3_a3": {
        this.emrservice.autoref.dkmra3 = this.selectValue;
        break;
      }


      case "un_kr_r4_p4": {
        this.emrservice.autoref.dkmrp4 = this.selectValue;
        break;
      }
      case "un_kr_r4_r4": {
        this.emrservice.autoref.dkmrr4 = this.selectValue;
        break;
      }
      case "un_kr_r4_a4": {
        this.emrservice.autoref.dkmra4 = this.selectValue;
        break;
      }


      case "un_kr_r5_p5": {
        this.emrservice.autoref.dkmrp5 = this.selectValue;
        break;
      }
      case "un_kr_r5_r5": {
        this.emrservice.autoref.dkmrr5 = this.selectValue;
        break;
      }
      case "un_kr_r5_a5": {
        this.emrservice.autoref.dkmra5 = this.selectValue;
        break;
      }


      case "un_kr_l1_p1": {
        this.emrservice.autoref.dkmlp1 = this.selectValue;
        break;
      }
      case "un_kr_l1_r1": {
        this.emrservice.autoref.dkmlr1 = this.selectValue;
        break;
      }
      case "un_kr_l1_a1": {
        this.emrservice.autoref.dkmla1 = this.selectValue;
        break;
      }

      case "un_kr_l2_p2": {
        this.emrservice.autoref.dkmlp2 = this.selectValue;
        break;
      }
      case "un_kr_l2_r2": {
        this.emrservice.autoref.dkmlr2 = this.selectValue;
        break;
      }
      case "un_kr_l2_a2": {
        this.emrservice.autoref.dkmla2 = this.selectValue;
        break;
      }

      case "un_kr_l3_p3": {
        this.emrservice.autoref.dkmlp3 = this.selectValue;
        break;
      }
      case "un_kr_l3_r3": {
        this.emrservice.autoref.dkmlr3 = this.selectValue;
        break;
      }
      case "un_kr_l3_a3": {
        this.emrservice.autoref.dkmla3 = this.selectValue;
        break;
      }

      case "un_kr_l4_p4": {
        this.emrservice.autoref.dkmlp4 = this.selectValue;
        break;
      }
      case "un_kr_l4_r4": {
        this.emrservice.autoref.dkmlr4 = this.selectValue;
        break;
      }
      case "un_kr_l4_a4": {
        this.emrservice.autoref.dkmla4 = this.selectValue;
        break;
      }

      case "un_kr_l5_p5": {
        this.emrservice.autoref.dkmlp5 = this.selectValue;
        break;
      }
      case "un_kr_l5_r5": {
        this.emrservice.autoref.dkmlr5 = this.selectValue;
        break;
      }
      case "un_kr_l5_a5": {
        this.emrservice.autoref.dkmla5 = this.selectValue;
        break;
      }
    }
    this.selectValue = '';
  }
  ngOnDestroy(): void {
    this.destroykeroto$.next(true);
    this.destroykeroto$.unsubscribe();
    this.dialatedcheck = null;
    this.machineArray=null;
    this.listmachineArray=null;
  }
}
